import { render, staticRenderFns } from "./CancellationPolicy.vue?vue&type=template&id=276c3223&"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports